import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical, TextP } from '../../..';
import { CheckBox } from '../General/Checkbox';
import { ProductFilterItem } from './ProductFilterItem';

interface Props {
  isMobile: boolean | false;
}

function ProductFilter({ isMobile }: Props) {
  return (
    <>
      <FilterItem isMobile={isMobile}>
        <ProductFilterItem name={'Cena'} type={'price'} />
      </FilterItem>
      <FilterCheckBoxItem isMobile={isMobile}>
        <CheckBoxWrapper>
          <CheckBox name="withVat" selected={true} rounded={true} />
          <StyledLabel htmlFor="withVat" selected={true}>
            {'s DPH'}
          </StyledLabel>
        </CheckBoxWrapper>
        <CheckBoxWrapper>
          <CheckBox name="withoutVat" selected={false} rounded={true} />
          <StyledLabel htmlFor="withoutVat" selected={false}>
            {'bez DPH'}
          </StyledLabel>
        </CheckBoxWrapper>
      </FilterCheckBoxItem>
      <FilterCheckBoxItem isMobile={isMobile}>
        <CheckBoxWrapper>
          <CheckBox name="voc" selected={true} rounded={true} />
          <StyledLabel htmlFor="voc" selected={true}>
            {'VOC'}
          </StyledLabel>
        </CheckBoxWrapper>
        <CheckBoxWrapper>
          <CheckBox name="moc" selected={false} rounded={true} />
          <StyledLabel htmlFor="moc" selected={false}>
            {'MOC'}
          </StyledLabel>
        </CheckBoxWrapper>
      </FilterCheckBoxItem>
      <FilterItem isMobile={isMobile}>
        <ProductFilterItem name={'Značka'} type={'select'} />
      </FilterItem>
      <FilterItem isMobile={isMobile}>
        <ProductFilterItem name={'Typ pripojenia'} type={'select'} />
      </FilterItem>
    </>
  );
}

const FilterItem = styled.div<{ isMobile: boolean | false }>`
  background: ${({ theme, isMobile }) =>
    !isMobile ? 'rgba(30, 57, 141, 0.04)' : theme.colors.white};
  padding: ${rem(32)};
  margin-bottom: ${rem(2)};

  &:first-child {
    border-radius: 4px 4px 0 0;
  }

  &:last-child {
    border-radius: 0 0 4px 4px;
  }
`;

export const ItemTitle = styled(TextP)`
  font-size: ${rem(20)};
  font-weight: 500;
`;

export const ItemTitleWrapper = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  cursor: pointer;
`;

export const CheckBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: ${rem(8)} 0;
`;

const StyledLabel = styled.label<{ selected: boolean }>`
  font-size: ${rem(16)};
  font-weight: ${({ selected }) => (selected ? 500 : 400)};
  margin-right: ${rem(24)};
  color: ${({ selected, theme }) =>
    selected ? '#1E398D' : theme.colors.textPrimary};
`;

const FilterCheckBoxItem = styled(FilterItem)`
  display: flex;
  flex-direction: row;
`;

export const TitleIconWrapper = styled.div``;

export { ProductFilter as DsiProductFilter };
